import { Node } from '@msdyn365-commerce-modules/utilities';
import { ProductDimensionValue } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as React from 'react';
import { IBuyboxGetDimensionPricingActionData } from '../../../data-actions/buybox-get-dimension-pricing-action';
import { IBuyboxGetDimensionVariantAvailabilityActionData } from '../../../data-actions/buybox-get-dimension-variants-availability-action';
import { fireAnalyticsLink } from '../../../Utilities/analytics/clickTrack';
import _getViewPort from '../../../Utilities/get-view-port';
import { _getActivePrices } from '../../../Utilities/mfrm-buybox-utils';
import { IBuyboxViewPropsExtended } from '../types';
import { IMfrmBuyboxProps } from '../mfrm-buybox.props.autogenerated';
import { IMfrmBuyBoxData } from '../mfrm-buybox.view';
import { BuyBoxSizeComponent } from './buybox-size-component';
import { BuyBoxSizeRedesignComponent } from './buybox-size-redesign-component';
import { Dropdown } from './dropdown/dropdown';
import { IDropdownItemProps } from './dropdown/dropdown.props';
import Listing from './listing';
import { HeightFoundationComponent } from './buybox-height-foundation-redesign-component';

export interface INotificationData {
    dropdownId: string;
    selectId: string;
    selectedValue: string;
}
export interface IModalDimensions {
    selectId: string;
    selectedValue: string;
    dropdownId: string;
    dimensionPrice?: number;
    discountAmount?: number;
    percentDiff?: string;
    dimensionLabel?: string;
}

export interface IProgressiveLeasingState {
    setLeasingButtonActive: React.Dispatch<React.SetStateAction<boolean>>;
}
export interface IVariantAvailabilityProps {
    variantAvailibilityList: IBuyboxGetDimensionVariantAvailabilityActionData[];
}

export interface IVariantSelected {
    setActiveVariant(variantID: number): void;
}

export interface IFinancingPerMonthCallbacks {
    setActiveVariantId(selectedVariantId: number | undefined): void;
}

// tslint:disable-next-line: max-func-body-length
export const BuyboxProductConfigureMfrm: React.FC<IBuyboxViewPropsExtended &
    IMfrmBuyboxProps<IMfrmBuyBoxData> &
    IProgressiveLeasingState &
    IVariantAvailabilityProps &
    IVariantSelected &
    IFinancingPerMonthCallbacks> = props => {
        const [sizeVariantsLength, setSizeVariantsLength] = React.useState<number>(0);
        const [isOpen, setIsOpen] = React.useState<boolean>(false); // modal toggle state
        const [isMobile, setisMobile] = React.useState<boolean>(false);
        const [selectedDisplayLabel, setselectedDisplayLabel] = React.useState<string>();
        const [selectedDimensionLabel, setSelectedDimensionLabel] = React.useState<string>();
        const [dimensionPrice, setDimensionPrice] = React.useState<number>();
        const [discountAmount, setDiscountAmount] = React.useState<number>();
        const [percentDiff, setPercentDiff] = React.useState<number>();
        const [selectedSize, setSetlectedSize] = React.useState('');
        const selectedVariantId = props.variantAvailibilityList.find(
            item => item.sizeValue && item.sizeValue.toLowerCase().trim() === selectedSize.toLowerCase().trim() && item.variantID === props.data.product?.result?.RecordId
        )?.variantID;
        const modalDimensionsArray: IModalDimensions[] = [];
        let preSelectedDimension: IModalDimensions = {
            selectId: '',
            selectedValue: '',
            dropdownId: ''
        };
        const { context } = props;
        React.useEffect(() => {
            const viewPort = _getViewPort(context);
            viewPort === 'xs' || viewPort === 'sm' ? setisMobile(true) : setisMobile(false);
        }, []);

        // VSI Customization - START - 47026
        React.useEffect(() => {
            props.state.currentProductDimensions && props.state.currentProductDimensions.length > 0
                && props.state.currentProductDimensions?.map((dimension, i) => {
                    const dropdownList: IDropdownItemProps[] = getDropdownList(dimension.DimensionValues);
                    if (dimension && dimension.DimensionTypeValue === 3) {
                        setSizeVariantsLength(dropdownList?.length ? dropdownList?.length : 0);
                    }
                });
        }, [props.state.currentProductDimensions]);

        React.useEffect(() => {
            props.setActiveVariantId(selectedVariantId);
        }, [selectedVariantId]);

        const getDropdownList = (dimensionValues: ProductDimensionValue[] | undefined): IDropdownItemProps[] => {
            const dropdownList = dimensionValues && dimensionValues?.length > 0
                ? dimensionValues.map<IDropdownItemProps>(dimensionValue => {
                    return {
                        value: dimensionValue.Value || '',
                        id: dimensionValue.RecordId.toString(),
                        selectedValue: (dimensionValue && dimensionValue.RecordId.toString()) || ''
                    };
                })
                : [];
            return dropdownList;
        };
        // VSI Customization - END - 47026

        const {
            context: {
                request: {
                    apiSettings: { baseImageUrl }
                }
            }
        } = props;
        const [activePrices, setActivePrices] = React.useState<IBuyboxGetDimensionPricingActionData[]>(props.data.dimensionPrices.result!);
        const [showColorPicker] = React.useState<boolean>(
            !!props.data.productSpecificationData.result
                ?.find(attr => attr.Name?.toLowerCase().trim() === props.config.eComDisplayColorLabel?.toLowerCase().trim())
                ?.TextValue?.toLowerCase()
        );
        React.useEffect(() => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            _getActivePrices(props.data.dimensionPrices.result!, props.context.actionContext).then(resultPrices => {
                setActivePrices(resultPrices);
            }).catch(err => console.log('Error', err));
        }, [props.data.dimensionPrices.result]);

        const generateOnClick = (id: number, valueId: string, variantID: number) => async (e: React.MouseEvent<HTMLElement>) => {
            fireAnalyticsLink({
                eventName: 'PDP-card-action',
                eventCategory: 'PDP Card Action',
                eventAction: 'Change Color',
                eventLabel: 'Change Color PDP',
                eventNoninteraction: 'false',
                enhancedAction: 'change_color',
                generalConfig: { enhanced_action: 'change_color' }
            });
            await props.callbacks.dimensionSelectedAsync(id, valueId);
        };
        const dropdownCallback = (notification: INotificationData): Promise<void> => {
            return new Promise((resolve, reject) => {
                resolve(props.callbacks.dimensionSelectedAsync(+notification.dropdownId, notification.selectId));
            });
        };
        const toggleBuyBoxModal = () => {
            setIsOpen(!isOpen);
        };
        const buyBoxModalAddItemClick = async (
            selectId: string,
            selectedValue: string,
            dropdownId: string,
            dimensionLabel?: string,
            isAddItemClick?: boolean
        ) => {
            setSetlectedSize(selectedValue);
            if (isAddItemClick) {
                fireAnalyticsLink({
                    eventName: 'PDP-card-action',
                    eventAction: 'Change Size',
                    eventCategory: 'PDP Card Action',
                    eventNoninteraction: 'false',
                    eventLabel: 'Change Size PDP',
                    enhancedAction: 'change_size',
                    generalConfig: { enhanced_action: 'change_size' }
                });
            }
            setIsOpen(false);
            props.setLeasingButtonActive(false);
            setselectedDisplayLabel(selectedValue);
            setSelectedDimensionLabel(dimensionLabel);
            isAddItemClick ? await dropdownCallback({ selectId: selectId, selectedValue: selectedValue, dropdownId: dropdownId }) : null;
            props.setLeasingButtonActive(true);
        };
        const calculatePercentage = (dimPrice: number, discountAmnt: number) => {
            const percentSaved = Math.round((discountAmnt / dimPrice) * 100);
            setPercentDiff(percentSaved);
            setDiscountAmount(discountAmnt);
            setDimensionPrice(dimPrice);
        };
        const formatCurrency = (price: number | undefined): string | undefined => {
            if (price === undefined) {
                return undefined;
            }
            return props.context.cultureFormatter.formatCurrency(price);
        };
        // tslint:disable-next-line: max-func-body-length
        const output = props.state.currentProductDimensions && props.state.currentProductDimensions.length > 0
            ? props.state.currentProductDimensions?.map((dimension, i) => {
                const {
                    data: {
                        productSpecificationData: { result }
                    },
                    config: { eComDisplayColorAsDropDown, eComDisplayColorLabel }
                } = props;
                // tslint:disable-next-line: max-line-length
                const displayAsDropdown =
                    result && eComDisplayColorAsDropDown
                        ? result.find(obj => obj.Name && obj.Name.toLowerCase().trim() === eComDisplayColorAsDropDown.toLowerCase().trim())
                            ?.BooleanValue
                        : ''; // Get EcomDisplayColorAsDropDown value
                const dropDownDisplayLabel =
                    result && eComDisplayColorLabel
                        ? result.find(obj => obj.Name && obj.Name.toLowerCase().trim() === eComDisplayColorLabel.toLowerCase().trim())
                            ?.TextValue
                        : ''; // Get EcomDisplayColorLabel value
                const dropdownName = props.callbacks.getDropdownName(dimension.DimensionTypeValue, props.resources);
                const dropdownId = dimension.DimensionTypeValue.toString();
                const dropdownToggleName = props.resources.selectDimensionFormatString?.replace('{0}', dropdownName.toLowerCase());
                const swatchName = props.callbacks.getDropdownName(dimension.DimensionTypeValue, props.resources).toLowerCase();
                const dropdownList: IDropdownItemProps[] = getDropdownList(dimension.DimensionValues);
                if (dimension && dimension.DimensionTypeValue === 1) {
                    const { DimensionTypeValue, DimensionValues, DimensionValue } = dimension;
                    // check if type of dimension is height since it also has a DimensionTypeValue of 1
                    // TODO: see if any other dimension types have a DimensionTypeValue of 1
                    const doesSelectedValueExist = props.variantAvailibilityList.filter(item => item.colorDimensionRecordId === dimension.DimensionValue?.RecordId && item.sizeValue === selectedSize).length;
                    const doesSelectedValueAvailable = props.variantAvailibilityList.find(item => item.colorDimensionRecordId === dimension.DimensionValue?.RecordId && item.sizeValue === selectedSize)?.isAvailable;
                    const availableOptions = props.variantAvailibilityList.filter(item => item.sizeValue.toLowerCase().trim() === selectedSize.toLowerCase().trim()).map(item => item.secondaryDimensionValue);
                    const availableDimensionValues = DimensionValues?.filter(item => availableOptions.includes(item.Value));
                    const alternativeOption = props.variantAvailibilityList.find(item => item.sizeValue.toLowerCase().trim() === selectedSize.toLowerCase().trim() && item.isAvailable === true)?.secondaryDimensionValue;
                    const dimensionValue = doesSelectedValueExist !== 0 && doesSelectedValueAvailable ? DimensionValue : DimensionValues?.find(item => item.Value === alternativeOption);
                    const selectedValue = (dimension.DimensionValue && dimension.DimensionValue.RecordId) || 'not available';
                    const isActive = selectedValue === DimensionValue?.RecordId;
                    const isVariantSelectionRedesignEnabled = props.config.enableVariantSelectionRedesign || false;

                    return (
                        <>
                            {(displayAsDropdown !== true || displayAsDropdown === null) && showColorPicker ?
                                <>
                                    <Node className='msc-buybox__custom-swatch' key={i}>
                                        {props.config.enableVariantSelectionRedesign ?
                                            <Node className='msc-buybox__custom-swatch__label-redesign'>
                                                <span className='msc-buybox__custom-swatch__color-label'>
                                                    {`${dropdownName.toUpperCase()}: `}
                                                    <span>{isVariantSelectionRedesignEnabled && isActive ? dimensionValue?.DimensionId : ''}</span>
                                                </span>
                                                <span className='msc-buybox__custom-swatch__number-of-colors'>{`${availableDimensionValues?.length} Colors`}</span>
                                            </Node> :
                                            <Node className='msc-buybox__custom-swatch__label'>
                                                {dropdownName} {dimensionValue && dimensionValue.Value ? (<span>{dimensionValue.Value}</span>) : false}
                                            </Node>
                                        }
                                        <Node className='swatches'>
                                            <Listing
                                                swatchName={swatchName}
                                                dimension={{ DimensionTypeValue, DimensionValues: availableDimensionValues, DimensionValue: dimensionValue }}
                                                generateOnClick={generateOnClick}
                                                baseImageUrl={baseImageUrl}
                                                availabilityList={props.variantAvailibilityList}
                                                selectedSize={selectedSize}
                                                setActiveVariant={props.setActiveVariant}
                                                selectedValueAvailable={doesSelectedValueAvailable}
                                                isVariantSelectionRedesignEnabled={props.config.enableVariantSelectionRedesign || false}
                                            />
                                        </Node>
                                    </Node>
                                    {/*  Keep original Color Dropdown hidden for SEO */}
                                    <Node className='ms-buybox__dropdown hidden'>
                                        <Node className='ms-buybox__dropdown-quantity-label'>{dropdownName}</Node>
                                        <Dropdown dropdownId={dropdownId} dropdownName={dropdownName} dropdownToggleName={dropdownToggleName} dropdownList={dropdownList} onChange={dropdownCallback} />
                                    </Node>
                                </>
                                :
                                null
                            }
                            {dropdownList.length > 1 && displayAsDropdown === true ?
                                <Node className={`${props.config.enableVariantSelectionRedesign ? 'ms-buybox__dropdown-redesign' : 'ms-buybox__dropdown'}`}>
                                    {props.config.enableVariantSelectionRedesign ? <Node className='ms-buybox__dropdown-quantity-label-redesign'>{`${dropDownDisplayLabel} :`}</Node> : <Node className='ms-buybox__dropdown-quantity-label my-auto'>{dropDownDisplayLabel}</Node>}
                                    {/* tslint:disable: max-line-length */}
                                    <div className='row'>
                                        {props.config.enableVariantSelectionRedesign ?
                                            <HeightFoundationComponent
                                                dimensionId={dropdownId}
                                                dimensionName={dropDownDisplayLabel && dropDownDisplayLabel ? dropDownDisplayLabel : ''}
                                                dimensionList={dropdownList}
                                                onChange={dropdownCallback}
                                                variantAvailibilityList={props.variantAvailibilityList}
                                                selectedSize={selectedSize}
                                                setActiveVariant={props.setActiveVariant}
                                                dimensionValue={dimension.DimensionValue} /> :
                                            <Dropdown
                                                dropdownId={dropdownId}
                                                dropdownName={dropDownDisplayLabel && dropDownDisplayLabel ? dropDownDisplayLabel : ''}
                                                dropdownToggleName={`Choose a ${dropDownDisplayLabel && dropDownDisplayLabel.trim().toLowerCase()}`}
                                                dropdownList={dropdownList}
                                                onChange={dropdownCallback}
                                                variantAvailibilityList={props.variantAvailibilityList}
                                                selectedSize={selectedSize}
                                                dimensionValue={dimension.DimensionValue}
                                            />
                                        }
                                    </div>
                                </Node>
                                :
                                null
                            }
                        </>
                    );

                } else if (dimension && dimension.DimensionTypeValue === 3) {
                    const { DimensionValue } = dimension;

                    dropdownList && dropdownList.length > 0 && dropdownList.forEach(item => {
                        let damount = 0;
                        let price = 0;
                        let percent = '';
                        let label;

                        activePrices &&
                            activePrices.forEach(size => {
                                if (size.name === item.value) {
                                    price = size.price;
                                    label = size.dimensionLabel;
                                    if (size.discountAmount) {
                                        damount = size.discountAmount;
                                        percent = damount > 0 ? Math.round((damount / price) * 100).toString() : '';
                                    }
                                }
                            });
                        if (item.value.trim().toLowerCase() === DimensionValue?.Value?.trim().toLowerCase()) {
                            preSelectedDimension = {
                                selectId: item.id,
                                selectedValue: item.value,
                                dropdownId: dropdownId,
                                discountAmount: damount,
                                dimensionPrice: price,
                                percentDiff: percent,
                                dimensionLabel: label
                            };
                            if ((discountAmount === undefined || discountAmount <= 0) && damount > 0) {
                                setDiscountAmount(damount);
                                const percentSaved = Math.round((damount / price) * 100);
                                setPercentDiff(percentSaved);
                            }
                        }
                        modalDimensionsArray.push({
                            selectId: item.id,
                            selectedValue: item.value,
                            dropdownId: dropdownId,
                            discountAmount: damount,
                            dimensionPrice: price,
                            percentDiff: percent,
                            dimensionLabel: label
                        });
                    });

                    // Hidden Size Dropdown with full dimensions for SEO
                    const SEODropdownList = modalDimensionsArray.map(productDimension => {
                        // tslint:disable-next-line: no-shadowed-variable
                        const { dimensionLabel, dimensionPrice, selectId, selectedValue } = productDimension;
                        // tslint:disable-next-line: no-unnecessary-local-variable
                        const SEODropDownItem = {
                            value: `${selectedValue} - ${dimensionLabel} - ${formatCurrency(dimensionPrice)}`,
                            id: selectId,
                            selectedValue: selectedValue
                        };

                        return SEODropDownItem;
                    });
                    return (// Keeping dropdown for ADA complianace hidden for now.
                        <Node className='ms-buybox__dropdown hidden' key={i}>
                            <Node className='ms-buybox__dropdown-quantity-label'>{dropdownName}</Node>
                            <Dropdown dropdownId={dropdownId} dropdownName={dropdownName} dropdownToggleName={dropdownToggleName} dropdownList={SEODropdownList} onChange={dropdownCallback} />
                        </Node>
                    );
                } else {
                    return (// Keeping dropdown for ADA complianace hidden for now.
                        <Node className='ms-buybox__dropdown hidden' key={i}>
                            <Node className='ms-buybox__dropdown-quantity-label'>{dropdownName}</Node>
                            <Dropdown
                                dropdownId={dropdownId}
                                dropdownName={dropdownName}
                                dropdownToggleName={dropdownToggleName}
                                dropdownList={dropdownList}
                                onChange={dropdownCallback}
                            />
                        </Node>
                    );
                }
            }) : undefined;

        return (
            <Node className='ms-buybox__configure'>
                {!props.config.enableVariantSelectionRedesign ?
                    <>
                        <BuyBoxSizeComponent
                            formatCurrencyFunc={formatCurrency}
                            percentFunc={calculatePercentage}
                            isOpen={isOpen}
                            onCloseModal={toggleBuyBoxModal}
                            isMobile={isMobile}
                            modalDimensions={modalDimensionsArray}
                            variantAvailibilityList={props.variantAvailibilityList}
                            addItemClick={buyBoxModalAddItemClick}
                            preSelection={preSelectedDimension}
                            outOfStockText={props.resources.outOfStockText}
                        />
                        {/* tslint:disable-next-line: cyclomatic-complexity */}
                        {sizeVariantsLength === 1 || sizeVariantsLength === 0 ? (
                            <Node className={'msc-single-value-no-toggle'} tabIndex='0'>
                                <label className='msc-size-label'>Size</label>
                                <div className='my-auto msc-selected-size-label-hide-caret'>
                                    <div className='row'>
                                        <div className='msc-variation-size'>
                                            <div className='msc-variation-size__size-label'>
                                                {selectedDisplayLabel ? selectedDisplayLabel : 'Select a Size'}
                                            </div>
                                            <div className='msc-variation-size__dimension-label'>{selectedDimensionLabel}</div>
                                        </div>
                                        <div
                                            className={discountAmount !== 0 ? 'msc-variation-total-price' : 'msc-variation-total-price-no-discount'}
                                        >
                                            {selectedDisplayLabel && discountAmount && dimensionPrice
                                                ? formatCurrency(dimensionPrice - discountAmount)
                                                : dimensionPrice
                                                    ? formatCurrency(dimensionPrice)
                                                    : ''
                                            }
                                            <br />
                                            <div className='msc-variation-price'>
                                                {selectedDisplayLabel && percentDiff && percentDiff !== 0 ? (
                                                    <span className='msc-variation-price-discount'>{percentDiff}% Off</span>
                                                ) : null}
                                                {selectedDisplayLabel && discountAmount ? (
                                                    <span className='msc-variation-actual-price'>&nbsp;{formatCurrency(dimensionPrice)}</span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Node>
                        ) : (
                            <Node
                                className={isOpen ? 'msc-modal-value-toggle focused' : 'msc-modal-value-toggle'}
                                onClick={sizeVariantsLength === 1 || sizeVariantsLength === 0 ? null : toggleBuyBoxModal}
                                tabIndex='0'
                            >
                                <label className='msc-size-label'>Size</label>
                                <div className='my-auto msc-selected-size-label'>
                                    <div className='row'>
                                        <div className='msc-variation-size'>
                                            <div className='msc-variation-size__size-label'>
                                                {selectedDisplayLabel ? selectedDisplayLabel : 'Select a Size'}
                                            </div>
                                            <div className='msc-variation-size__dimension-label'>{selectedDimensionLabel}</div>
                                        </div>
                                        <div
                                            className={discountAmount !== 0 ? 'msc-variation-total-price' : 'msc-variation-total-price-no-discount'}
                                        >
                                            {selectedDisplayLabel && discountAmount && dimensionPrice
                                                ? formatCurrency(dimensionPrice - discountAmount)
                                                : formatCurrency(dimensionPrice)}
                                            <br />
                                            <div className='msc-variation-price'>
                                                {selectedDisplayLabel && percentDiff && percentDiff !== 0 ? (
                                                    <span className='msc-variation-price-discount'>{percentDiff}% Off</span>
                                                ) : null}
                                                {selectedDisplayLabel && discountAmount ? (
                                                    <span className='msc-variation-actual-price'>&nbsp;{formatCurrency(dimensionPrice)}</span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Node>
                        )}
                    </>
                    : <>
                        {modalDimensionsArray.length !== 0 && <p className='msc-dimensions-lable'>Size: <span>{preSelectedDimension?.dimensionLabel !== undefined && preSelectedDimension?.dimensionLabel}</span></p>}
                        <BuyBoxSizeRedesignComponent
                            percentFunc={calculatePercentage}
                            sizeDimensions={modalDimensionsArray}
                            variantAvailibilityList={props.variantAvailibilityList}
                            addItemClick={buyBoxModalAddItemClick}
                            preSelection={preSelectedDimension}
                            outOfStockText={props.resources.outOfStockText}
                            variantMappingConfig={props.config.variantNameMapping}
                        />
                    </>
                }
                {output}
            </Node>
        );
    };
